import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import MrnService from "../services/MrnService";

const useMrnService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new MrnService(client);
  }, [client]);

  return service;
};

export default useMrnService;
